import React from 'react';
import { Redirect } from 'react-router';
import { ERoutesPrivate } from 'common/models/routesModel';

export const RootFranchisorPage: React.FC = () => <Redirect to={ERoutesPrivate.Users} />;
